import { UrlApi } from "../../../../../../../../services/apirest";

export const getImputacionesByRecibo = async (idRecibo) => {
  const res = await fetch(`${UrlApi}/ctacte/recibos/imputaciones/${idRecibo}`);

  if (!res.ok) throw new Error("Error al obtener imputaciones");

  return res.json();
};

export const desaplicarImputaciones = async ({ idRecibo, ids, user }) => {
  const res = await fetch(`${UrlApi}/ctacte/recibos/anularImputaciones`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ idRecibo, ids, user }),
  });

  if (!res.ok) throw new Error("Error al desaplicar");

  return res.json();
};
